import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import Swal from 'sweetalert2';
import {AuthenticationService} from '../services/authentication.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    providers: [AuthenticationService]
})
export class LoginComponent implements OnInit {

    email: string;
    password: string;
    loading = false;

    constructor(private router: Router,
                private authService: AuthenticationService) {
    }

    authenticate(e) {
        e.preventDefault();
        this.loading = true;
        const user = {
            'email': this.email,
            'password': this.password
        };
        this.authService.login(user).subscribe(response => {
                const res = response.data;
                if (res.statusCode === 200) {
                    if (res.user.roles.length === 0) {
                        this.loading = false;
                        Swal({type: 'info', title: 'You don\'t have any roles attached!'});
                        this.router.navigate(['']);
                    } else {
                        for (let i = 0; i < res.user.roles.length; i++) {
                            if (res.user.roles[i].hasOwnProperty('role_name')) {
                                this.authService.setToken(res.token);
                                this.authService.setTokenTime(res.token_expiry_time);
                                this.authService.setUser(JSON.stringify(res.user));
                                this.router.navigate(['/home']);
                            }
                        }
                    }
                } else if (res.statusCode === 403) {
                    this.loading = false;
                    Swal({type: 'warning', title: 'Incorrect Password', text: response.data.message});
                    this.router.navigate(['']);
                } else if (res.statusCode === 401) {
                    this.loading = false;
                    Swal({type: 'warning', title: 'User Not Registered', text: response.data.message});
                    this.router.navigate(['']);
                } else if (res.statusCode === 500) {
                    this.loading = false;
                    Swal({type: 'error', title: 'Server Error', text: response.data.message});
                    this.router.navigate(['']);
                }  else if (res.statusCode === 400) {
                    this.loading = false;
                    Swal({type: 'info', title: 'Insufficient information', text: response.data.message});
                    this.router.navigate(['']);
                } else {
                    this.loading = false;
                    Swal({type: 'error', title: 'Error', text: 'Contact Support Team.'});
                    this.router.navigate(['']);
                }
            },
            error => {
                this.loading = false;
                Swal({type: 'error', title: 'Error', text: 'Could\'nt login due to an error!'});
                this.router.navigate(['']);
                console.log(error);
            });
    }

      getMyPassword() {
        const that = this;
        let emailResponse;
    
        Swal({
            text: 'Enter your Registered email',
            input: 'email',
            inputPlaceholder: 'user@email.com',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            padding: 80,
            confirmButtonText: 'Get My Password',
            showLoaderOnConfirm: true,
            preConfirm: (email) => {
                const options = {
                    email: email
                };
                return new Promise((resolve, reject) => {
                    that.authService.getMyPassword(options).subscribe(data => {
                        emailResponse = data;
                        resolve(emailResponse);
                    }, error => {
                        emailResponse = error;
                        reject(emailResponse);
                    });
                });
            }
        }).then(
            (result) => {
                if (result && result.value) {
                    if (emailResponse && emailResponse.status === 'success') {
                        Swal({type: 'success', title: 'success', text: emailResponse.message});
                        // that.toastr.success('Success', emailResponse.message);
                    } else if (emailResponse && emailResponse.status === 'fail') {
                        Swal({type: 'warning', title: 'Fail', text: emailResponse.message});
                        // that.toastr.error('Fail', emailResponse.message);
                    }
                } else {
                   // that.toastr.info('There is an error. Please contact support team');
                }
            }
        ).catch((error) => {
            console.log(error);
        });
    }

    // getMyPassword() {
    //     const that = this;
    //     let emailResponse;
    //     Swal({
    //         text: 'Enter your allottedUniversity email',
    //         input: 'email',
    //         inputPlaceholder: 'user@iimb.ac.in',
    //         inputAttributes: {
    //             autocapitalize: 'off'
    //         },
    //         showCancelButton: true,
    //         confirmButtonClass: 'btn btn-outline-success rounded-0',
    //         cancelButtonClass: 'btn btn-outline-danger rounded-0',
    //         cancelButtonColor: '#d33',
    //         confirmButtonColor: '#5cb85c',
    //         padding: 80,
    //         confirmButtonText: 'Get My Password',
    //         showLoaderOnConfirm: true,
    //         preConfirm: (email) => {
    //             return new Promise(function (resolve, reject) {
    //                 that.authService.getMyPassword(email).subscribe(data => {
    //                     emailResponse = data;
    //                     resolve(emailResponse);
    //                 }, error => {
    //                     emailResponse = error;
    //                     reject(emailResponse);
    //                 });
    //             });
    //         }
    //     }).then((result) => {
    //         if (result.hasOwnProperty('value')) {
    //             if (emailResponse.status === 'success' && emailResponse.data === true) {
    //                 Swal({
    //                     title: 'Success',
    //                     type: 'success',
    //                     showCancelButton: false,
    //                     showConfirmButton: true,
    //                     html: '<p>Password sent to your email address.</p>',
    //                 });
    //             } else if (emailResponse.status === 'fail') {
    //                 const responseMessage = emailResponse.data;
    //                 if (responseMessage.hasOwnProperty('message')) {
    //                     Swal({
    //                         type: 'error',
    //                         title: 'Fail',
    //                         html: responseMessage.message,
    //                     });
    //                 } else if (responseMessage === null || responseMessage === '') {
    //                     Swal({
    //                         type: 'error',
    //                         title: 'Fail',
    //                         html: 'The user is not found.',
    //                     });
    //                 } else {
    //                     Swal({
    //                         type: 'error',
    //                         title: 'Fail',
    //                         html: '<p>There is an error.<br>Please contact support team.</p>',
    //                     });
    //                 }
    //             } else {
    //                 Swal({
    //                     title: 'Fail',
    //                     html: '<p>There is an error.<br>Please contact support team.</p>',
    //                 });
    //             }
    //         }
    //     }, function (cancel) {
    //         console.log(cancel);
    //     }).catch(function (error) {
    //         console.log(error);
    //     });
    // }

    ngOnInit() {
        if (localStorage.getItem('epas_user') !== null && localStorage.getItem('epas_user') !== '' &&
            localStorage.getItem('epas_user') !== undefined) {
            const epasUser = JSON.parse(localStorage.getItem('epas_user'));
            if (epasUser.hasOwnProperty('roles')) {
                for (let i = 0; i < JSON.parse(localStorage.getItem('epas_user')).roles.length; i++) {
                    if (JSON.parse(localStorage.getItem('epas_user')).roles[i].hasOwnProperty('role_name')) {
                        this.router.navigate(['/home']);
                    }
                }
            } else {
                this.authService.logout();
            }
        }
    }
}
